// Money formatter honoring the store's money format (set in layout/theme.liquid)
function formatThemeMoney(cents) {
    const format = window.themeMoneyFormat || '${{amount}}';
    const fixed = (cents / 100).toFixed(2);
    const parts = fixed.split('.');
    const thousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const thousandsDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
        .replace(/\{\{\s*amount\s*\}\}/g, `${thousands}.${parts[1]}`)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, thousands)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${thousandsDot},${parts[1]}`)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, thousandsDot);
}
window.formatThemeMoney = formatThemeMoney;

document.addEventListener('DOMContentLoaded', () => {
    // Backdrop selector
    const backdrop = document.getElementById('mobile-menu-backdrop');
    
    const drawers = {
        menu: {
            el: document.getElementById('mobile-menu'),
            btn: document.getElementById('mobile-menu-btn'),
            desktopBtn: document.getElementById('desktop-menu-btn'),
            open: () => {
                drawers.menu.el.classList.remove('translate-x-full');
                drawers.menu.btn.textContent = 'Close';
                if (drawers.menu.desktopBtn) drawers.menu.desktopBtn.textContent = 'Close';
            },
            close: () => {
                drawers.menu.el.classList.add('translate-x-full');
                drawers.menu.btn.textContent = 'Menu';
                if (drawers.menu.desktopBtn) drawers.menu.desktopBtn.textContent = 'Menu';
            }
        },
        search: {
            el: document.getElementById('search-drawer'),
            triggers: document.querySelectorAll('.search-trigger'),
            closeBtn: document.getElementById('search-close-btn'),
            open: () => {
                drawers.search.el.classList.remove('translate-x-full');
            },
            close: () => {
                drawers.search.el.classList.add('translate-x-full');
            }
        },
        cart: {
            el: document.getElementById('cart-drawer'),
            triggers: document.querySelectorAll('.cart-trigger'),
            closeBtn: document.getElementById('cart-close-btn'),
            open: () => {
                drawers.cart.el.classList.remove('translate-x-full');
            },
            close: () => {
                drawers.cart.el.classList.add('translate-x-full');
            }
        }
    };

    let activeDrawer = null;

    const openDrawer = (type) => {
        if (activeDrawer) {
            drawers[activeDrawer].close();
        }
        drawers[type].open();
        activeDrawer = type;
        
        if (type === 'menu') {
            backdrop.classList.remove('z-[55]');
            backdrop.classList.add('z-30');
        } else {
            backdrop.classList.remove('z-30');
            backdrop.classList.add('z-[55]');
        }
        
        backdrop.classList.remove('hidden');
        setTimeout(() => backdrop.classList.add('opacity-100'), 10);
        document.body.classList.add('overflow-hidden');
    };

    const closeAllDrawers = () => {
        if (activeDrawer) {
            drawers[activeDrawer].close();
            activeDrawer = null;
        }
        backdrop.classList.remove('opacity-100');
        setTimeout(() => backdrop.classList.add('hidden'), 300);
        document.body.classList.remove('overflow-hidden');
    };

    // Expose openDrawer globally so template event listeners can call it
    window.openCartDrawer = () => openDrawer('cart');

    // Bind triggers
    if (drawers.menu.btn) {
        drawers.menu.btn.addEventListener('click', () => {
            if (activeDrawer === 'menu') {
                closeAllDrawers();
            } else {
                openDrawer('menu');
            }
        });
    }
    if (drawers.menu.desktopBtn) {
        drawers.menu.desktopBtn.addEventListener('click', () => {
            if (activeDrawer === 'menu') {
                closeAllDrawers();
            } else {
                openDrawer('menu');
            }
        });
    }

    drawers.search.triggers.forEach(t => t.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer('search');
    }));
    if (drawers.search.closeBtn) drawers.search.closeBtn.addEventListener('click', closeAllDrawers);

    drawers.cart.triggers.forEach(t => t.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer('cart');
    }));
    if (drawers.cart.closeBtn) drawers.cart.closeBtn.addEventListener('click', closeAllDrawers);

    if (backdrop) backdrop.addEventListener('click', closeAllDrawers);

    // Sticky Scroll Controller (Index page only)
    const logoRow = document.getElementById('logo-row');
    const logoText = document.getElementById('logo-text');
    const stickyLogoDesktop = document.getElementById('sticky-logo-container');
    const stickyLogoMobile = document.getElementById('sticky-logo-mobile');

    const handleScroll = () => {
        if (window.scrollY > 100) {
            if (logoRow) logoRow.classList.add('logo-row-collapsed');
            if (logoText) logoText.classList.add('logo-text-collapsed');
            if (stickyLogoDesktop) stickyLogoDesktop.classList.add('sticky-logo-active');
            if (stickyLogoMobile) stickyLogoMobile.classList.add('sticky-logo-active');
        } else {
            if (logoRow) logoRow.classList.remove('logo-row-collapsed');
            if (logoText) logoText.classList.remove('logo-text-collapsed');
            if (stickyLogoDesktop) stickyLogoDesktop.classList.remove('sticky-logo-active');
            if (stickyLogoMobile) stickyLogoMobile.classList.remove('sticky-logo-active');
        }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check

    // Carousel Controller: supports multiple carousels per page (scoped, no duplicate IDs)
    document.querySelectorAll('[data-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-carousel-track]');
        const prevBtn = carousel.querySelector('[data-carousel-prev]');
        const nextBtn = carousel.querySelector('[data-carousel-next]');
        if (!track || !prevBtn || !nextBtn) return;

        prevBtn.addEventListener('click', () => {
            track.scrollBy({ left: -300, behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', () => {
            track.scrollBy({ left: 300, behavior: 'smooth' });
        });
    });

    // Shopify AJAX Cart Integration
    function updateCartUIState(cart) {
        const container = document.getElementById('cart-items-container');
        const subtotalEl = document.getElementById('cart-subtotal-val');
        if (!container) return;

        const allProductsUrl = (window.themeRoutes && window.themeRoutes.allProducts) || '/collections/all';

        if (!cart || cart.item_count === 0) {
            container.innerHTML = `
                <div class="text-center py-12">
                    <p class="text-xs font-bold tracking-[0.2em] text-zinc-400 uppercase">Your cart is empty</p>
                    <a href="${allProductsUrl}" class="inline-block bg-black text-white text-[10px] font-bold tracking-[0.2em] uppercase py-3 px-6 mt-6 hover:bg-zinc-800 transition-colors">Shop All</a>
                </div>
            `;
            if (subtotalEl) subtotalEl.textContent = formatThemeMoney(0);
            return;
        }

        container.innerHTML = cart.items.map((item, index) => {
            const itemPriceFormatted = formatThemeMoney(item.final_line_price);
            const variantTitle = item.variant_title ? item.variant_title : 'Default';
            return `
                <div class="flex gap-4 border-b border-zinc-200 pb-4 justify-between items-center">
                    <div class="flex gap-4 items-center">
                        <img src="${item.image ? item.image : 'https://cdn.shopify.com/s/images/admin/no-image-large.gif'}" alt="${item.product_title}" class="w-12 h-16 object-cover border border-black bg-zinc-50" />
                        <div class="flex flex-col gap-1">
                            <span class="text-[10px] font-bold uppercase tracking-wider">${item.product_title}</span>
                            <span class="text-[8px] text-zinc-400 uppercase">Size/Style: ${variantTitle}</span>
                            <div class="flex items-center gap-2 mt-1">
                                <button onclick="changeQty(${index}, ${item.quantity - 1})" class="w-4 h-4 border border-black flex items-center justify-center font-bold hover:bg-zinc-100 text-[8px]">-</button>
                                <span class="text-[9px] font-bold px-1">${item.quantity}</span>
                                <button onclick="changeQty(${index}, ${item.quantity + 1})" class="w-4 h-4 border border-black flex items-center justify-center font-bold hover:bg-zinc-100 text-[8px]">+</button>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col items-end gap-1">
                        <span class="text-[10px] font-bold">${itemPriceFormatted}</span>
                        <button onclick="removeItem(${index})" class="text-[8px] text-zinc-400 font-bold uppercase hover:text-black">Remove</button>
                    </div>
                </div>
            `;
        }).join('');
        if (subtotalEl) subtotalEl.textContent = formatThemeMoney(cart.total_price);
    }

    window.changeQty = (index, newQty) => {
        const line = index + 1;
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: newQty })
        })
        .then(res => {
            if (!res.ok) throw new Error(`Cart change failed (${res.status})`);
            return res.json();
        })
        .then(cart => {
            updateCartUIState(cart);
            // Trigger cart page reload if available
            if (typeof window.renderPageCart === 'function') {
                window.renderPageCart(cart);
            }
        })
        .catch(err => {
            console.error('[theme] Could not update cart:', err);
        });
    };

    window.removeItem = (index) => {
        window.changeQty(index, 0);
    };

    window.quickAdd = (variantId) => {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
        .then(res => {
            if (!res.ok) throw new Error(`Add to cart failed (${res.status})`);
            return res.json();
        })
        .then(() => fetch('/cart.js'))
        .then(res => {
            if (!res.ok) throw new Error(`Cart fetch failed (${res.status})`);
            return res.json();
        })
        .then(cart => {
            updateCartUIState(cart);
            if (typeof window.renderPageCart === 'function') {
                window.renderPageCart(cart);
            }
            openDrawer('cart');
        })
        .catch(err => {
            console.error('[theme] Could not add item to cart:', err);
            throw err;
        });
    };

    // Load initial cart state
    fetch('/cart.js')
    .then(res => {
        if (!res.ok) throw new Error(`Cart fetch failed (${res.status})`);
        return res.json();
    })
    .then(cart => {
        updateCartUIState(cart);
    })
    .catch(err => {
        console.error('[theme] Could not load cart state:', err);
    });
});
